import { render, staticRenderFns } from "./insurance3.vue?vue&type=template&id=7b457368&scoped=true"
import script from "./insurance3.vue?vue&type=script&lang=js"
export * from "./insurance3.vue?vue&type=script&lang=js"
import style0 from "./insurance3.vue?vue&type=style&index=0&id=7b457368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b457368",
  null
  
)

export default component.exports